import styled from '@emotion/styled';
import { IInputsForSC } from '../../inputs.models';
import { input } from '../../inputs.style';

export const Input = styled.input<IInputsForSC>`
  ${input}
`;

